module.exports = __webpack_public_path__ + "static/media/house-damage.149fd5b4.svg";